(function(){
  if(window.__ordo2Init) return;
  window.__ordo2Init = 1;

  var d=document;
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* ---------- Ajout au panier sans rechargement, bouton qui morphe ---------- */
  var ICON_S = '<span class="o-btn__s" aria-hidden="true"><i></i></span>';
  var ICON_K = '<span class="o-btn__k" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M4.5 12.5l5 5 10-11" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  function dress(btn){
    if(btn.dataset.oDressed) return;
    btn.dataset.oDressed = '1';
    btn.innerHTML = '<span class="o-btn__l">' + btn.innerHTML + '</span>' + ICON_S + ICON_K;
    btn.setAttribute('data-state','idle');
  }

  function bump(n){
    d.querySelectorAll('[data-o-cart-count], .cart-count, [data-cart-count]').forEach(function(el){
      el.textContent = n;
    });
  }

  /* Une couleur par brosse : on construit une ligne de panier par selecteur visible. */
  function payload(form){
    var vis = form.querySelectorAll('[data-o-vslot]:not([hidden]) select[data-o-vsel]');
    if(vis.length > 1){
      var items = [];
      vis.forEach(function(s){
        var id = parseInt(s.value, 10);
        if(id) items.push({ id: id, quantity: 1 });
      });
      if(items.length){
        return { body: JSON.stringify({ items: items }),
                 headers: { 'Content-Type':'application/json', 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' } };
      }
    }
    return { body: new FormData(form),
             headers: { 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' } };
  }

  var busy = false;
  d.addEventListener('submit', function(ev){
    var form = ev.target;
    if(!form || !form.action || String(form.action).indexOf('/cart/add') === -1) return;
    var btn = form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
    if(!btn || btn.disabled) return;
    ev.preventDefault();
    if(busy) return;
    busy = true;

    dress(btn);
    btn.style.minInlineSize = btn.offsetWidth + 'px';
    btn.setAttribute('data-state','load');

    var pl = payload(form);

    fetch(root() + 'cart/add.js', { method:'POST', headers:pl.headers, body:pl.body })
    .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
    .then(function(){ return fetch(root() + 'cart.js', { headers:{ 'Accept':'application/json' } }); })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      bump(cart.item_count);
      btn.setAttribute('data-state','done');
      d.dispatchEvent(new CustomEvent('ordo:cart:added', { detail:{ cart:cart } }));
      try{
        var dr = d.querySelector('cart-drawer, #cart-drawer, .cart-drawer');
        if(dr && typeof dr.open === 'function'){ dr.open(); }
      }catch(e){}
      setTimeout(function(){
        btn.setAttribute('data-state','idle');
        btn.style.minInlineSize = '';
        busy = false;
      }, 1300);
    })
    .catch(function(){
      btn.setAttribute('data-state','idle');
      btn.style.minInlineSize = '';
      busy = false;
      form.submit();
    });
  });

  /* ---------- Chiffres qui montent quand ils entrent dans l'ecran ---------- */
  function counters(){
    var els = d.querySelectorAll('[data-count]:not([data-counted])');
    if(!els.length || mqReduce.matches || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        var el = en.target;
        el.setAttribute('data-counted','1');
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-count'));
        if(isNaN(target)) return;
        var suffix = el.getAttribute('data-suffix') || '';
        var t0 = null, dur = 900;
        function step(t){
          if(t0 === null) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * e) + suffix;
          if(p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold:0.5 });
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------- Titre du hero, mots en cascade ---------- */
  function heroWords(){
    var h = d.querySelector('[data-o-words]:not([data-o-split])');
    if(!h) return;
    h.setAttribute('data-o-split','1');
    if(mqReduce.matches) return;
    var words = h.textContent.trim().split(/\s+/);
    h.textContent = '';
    words.forEach(function(w, i){
      var s = d.createElement('span');
      s.className = 'o-hero__w';
      s.textContent = w;
      s.style.setProperty('--o-wd', (i * 55) + 'ms');
      h.appendChild(s);
      h.appendChild(d.createTextNode(' '));
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ s.classList.add('is-in'); }); });
    });
  }

  /* ---------- Panier : quantite et suppression sans rechargement ---------- */
  function cartPage(){
    var wrap = d.querySelector('[data-o-cart]');
    if(!wrap || wrap.dataset.oInit) return;
    wrap.dataset.oInit = '1';
    wrap.addEventListener('click', function(ev){
      var b = ev.target.closest('[data-o-line]');
      if(!b) return;
      ev.preventDefault();
      var row = b.closest('.o-pn__i');
      var line = b.getAttribute('data-o-line');
      var qty  = b.getAttribute('data-o-qty');
      if(row) row.setAttribute('data-busy','');
      fetch(root() + 'cart/change.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ line: parseInt(line,10), quantity: parseInt(qty,10) })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ window.location.reload(); })
      .catch(function(){ if(row) row.removeAttribute('data-busy'); });
    });
  }

  function init(){ counters(); heroWords(); cartPage(); }
  if(d.readyState === 'loading'){ d.addEventListener('DOMContentLoaded', init); } else { init(); }
  d.addEventListener('shopify:section:load', init);
})();
